import { render, staticRenderFns } from "./agentStudentList.vue?vue&type=template&id=42b3514c&scoped=true"
import script from "./agentStudentList.vue?vue&type=script&lang=js"
export * from "./agentStudentList.vue?vue&type=script&lang=js"
import style0 from "./agentStudentList.vue?vue&type=style&index=0&id=42b3514c&prod&lang=less"
import style1 from "./agentStudentList.vue?vue&type=style&index=1&id=42b3514c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b3514c",
  null
  
)

export default component.exports